import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiService } from '@meddatacore/common';
import { Schedule, ScheduleDateFilter, ScheduleOwnerEvent } from "../../models/schedule";

@Injectable({ providedIn: 'root' })
export class ScheduleService extends ApiService {
  endPoint = '/api/schedule';
  create(model: Schedule) {
    return this.http.post(`${this.scheduleBaseURL}${this.endPoint}`, model);
  }

  update(id: string, model: Schedule) {
    return this.http.put(`${this.scheduleBaseURL}${this.endPoint}/${id}`, model);
  }

  getOwnerSchedule(ownerId: string): Observable<Schedule> {
    return this.http.get<Schedule>(`${this.scheduleBaseURL}${this.endPoint}/owner/${ownerId}`);
  }

  getOwnersSchedules(ownerIds: string[], isPersonal = false): Observable<Schedule[]> {
    return this.http.post<Schedule[]>(`${this.scheduleBaseURL}${this.endPoint}/owners/schedules`, { ownerIds, isPersonal });
  }

  getScheduleOwnerEvents(filter: ScheduleDateFilter): Observable<ScheduleOwnerEvent[]> {
    return this.http.post<ScheduleOwnerEvent[]>(`${this.scheduleBaseURL}${this.endPoint}/owners/schedule-events`, filter);
  }
}
